import axios from 'axios'
import { CALCULAR_DESCONTO_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function calcularDescontoUsuario (valorTotal, percentualDesconto) {
  const url = `${URL}/passagem/valor/${valorTotal}/desconto/${percentualDesconto}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CALCULAR_DESCONTO_USUARIO,
        payload: response

      })
  );
}
